import type { AnchorHTMLAttributes, ComponentType, PropsWithChildren } from "react";
import { createContext, useContext } from "react";

export type LinkWrapperProps = PropsWithChildren<AnchorHTMLAttributes<HTMLAnchorElement>>;

export const LinkBehaviourContext = createContext<ComponentType<LinkWrapperProps> | null>(null);

export const useLink = () => {
  return useContext(LinkBehaviourContext);
};
